import { getApiClient } from '@treneo/infrastructure/api';

import { ConfigApi } from './config.api';

export const configApi = new ConfigApi(getApiClient());
export * from './config.api';
